import type { ReactElement } from 'react'

import Modal from '~/components/Modal'
import { ModalBody, ModalHeader } from '~/components/Modal/Layout'

import './styles.scss'

interface Props {
  email: string
  isOpen: boolean
  onClose: VoidFunction
  phone: string
}

const CompanyContactModal = ({ email, isOpen, onClose, phone }: Props): ReactElement => {
  const emails = email ? email.split(',') : []
  const phoneNumbers = phone ? phone.split(',') : []

  return (
    <Modal className="company-contact-modal" isOpen={isOpen} onCloseModal={onClose}>
      <ModalHeader>Contact info</ModalHeader>
      <ModalBody>
        {emails.length > 0 ? (
          <div className="company-contact-modal__section">
            <span>Emails</span>
            <ul>
              {emails.map((el, idx) => (
                <li key={idx}>{el}</li>
              ))}
            </ul>
          </div>
        ) : null}
        {emails.length > 0 && phoneNumbers.length > 0 ? <hr className="company-contact-modal__separator" /> : null}
        {phoneNumbers.length > 0 ? (
          <div className="company-contact-modal__section">
            <span>Phones</span>
            <ul>
              {phoneNumbers.map((el, idx) => (
                <li key={idx}>{el}</li>
              ))}
            </ul>
          </div>
        ) : null}
      </ModalBody>
    </Modal>
  )
}

export default CompanyContactModal
